"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryRoleSchema = exports.BoundaryRole = void 0;
const zod_1 = require("zod");
var BoundaryRole;
(function (BoundaryRole) {
    BoundaryRole["Driver"] = "driver";
    BoundaryRole["Acceptor"] = "acceptor";
    BoundaryRole["Constraint"] = "constraint";
})(BoundaryRole || (exports.BoundaryRole = BoundaryRole = {}));
exports.BoundaryRoleSchema = zod_1.z.nativeEnum(BoundaryRole);
//# sourceMappingURL=BoundaryRole.js.map